import { apiGet } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';
import type { MetricasEntrega } from '../../types/metricasNotificacoes';

export interface NotificacoesMetricasParams {
  escritorioId?: string;
  periodo?: string;
  dataInicio?: string;
  dataFim?: string;
  origem?: string;
}

const BASE_URL = '/admin/notificacoes/metricas';

export const notificacoesMetricasService = {
  async get(params: NotificacoesMetricasParams = {}): Promise<MetricasEntrega> {
    const query: Record<string, string> = {};
    if (params.escritorioId) query.escritorioId = params.escritorioId;
    if (params.periodo) query.periodo = params.periodo;
    if (params.dataInicio) query.dataInicio = params.dataInicio;
    if (params.dataFim) query.dataFim = params.dataFim;
    if (params.origem) query.origem = params.origem;
    const response = await apiGet(BASE_URL, query);
    return parseApiResponse<MetricasEntrega>(response);
  },
};
